/**
 * Version-check web: compara el build id embebido en el bundle corriendo
 * (EXPO_PUBLIC_BUILD_ID, inyectado en el build de Vercel) contra el build id
 * deployado (app_release_config.web_build_id via Realtime, o /version.json
 * como fallback al volver al foco).
 *
 * Módulo hoja sin imports de app para reuso sin require cycles.
 */
import { Platform } from 'react-native';

/** Build id del bundle que está corriendo. null en nativo o builds sin env. */
export function getRunningWebBuildId(): string | null {
  if (Platform.OS !== 'web') return null;
  const id = process.env.EXPO_PUBLIC_BUILD_ID;
  return typeof id === 'string' && id.trim() ? id.trim() : null;
}

/** True solo si ambos ids existen y difieren. Ids vacíos → false (fail-safe). */
export function isWebBuildStale(
  running: string | null,
  deployed: string | null | undefined,
): boolean {
  if (!running || !deployed) return false;
  const deployedId = deployed.trim();
  if (!deployedId) return false;
  return running !== deployedId;
}

/** Parsea el payload de GET /version.json ({ buildId }). null si malformado. */
export function parseVersionJsonBuildId(raw: unknown): string | null {
  if (raw == null || typeof raw !== 'object') return null;
  const id = (raw as { buildId?: unknown }).buildId;
  return typeof id === 'string' && id.trim() ? id.trim() : null;
}
